import React from 'react';
import config from '../config';
import DashboardInitializer from '../dashboards/DashboardInitializer';
import apiPaths from '../apiPaths';

const EvaluacionDashboard = (props) => {
  const components = [
    {
      params: {
        type: 'search',
        componentId: 'evaluacionevaluacionSearch',
        panelHeader: 'Avaluació',
        panelKey: 'evaluacionevaluacionSearch',
        yPosition: 0,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabIndex: 0,
        tabTitle: '',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 0,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'nivel',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fechaCreacion',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 16,
                },
                {
                  key: 'fkArea.id',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'fkClase.id',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'fkEducador.id',
                  yPosition: 2,
                  xPosition: 3,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'fkEvaluacion.id',
                  yPosition: 2,
                  xPosition: 4,
                  mustRender: true,
                  width: 6,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Nivell',
          key: 'nivel',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Data Creació',
          key: 'fechaCreacion',
          type: 'rangerpicker',
          operand: 'like',
          format: 'timestamp',
          displayFormat: 'DD-MM-YYYY',
        },
        {
          title: 'Àrea',
          key: 'fkArea.id',
          type: 'combo',
          operand: 'like',
          comboId: 'area',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Classe',
          key: 'fkClase.id',
          type: 'combo',
          operand: 'like',
          comboId: 'clase',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Educador',
          key: 'fkEducador.id',
          type: 'combo',
          operand: 'like',
          comboId: 'educador',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Avaluació',
          key: 'fkEvaluacion.id',
          type: 'combo',
          comboId: 'evaluacion',
          operand: 'like',
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
      },
    },
    {
      params: {
        type: 'table',
        componentId: 'evaluacionevaluacionList',
        rowKey: 'id',
        panelHeader: 'Avaluació',
        panelKey: 'evaluacionevaluacionList',
        navigationParams: props.query.params.q || '',
        yPosition: 1,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabTitle: '',
        isMainTable: true,
        tabIndex: 0,
        tableType: 0,
      },
      fields: [
        {
          title: 'Id',
          dataIndex: 'id',
          position: 0,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          width: 60,
        },
        {
          title: 'Nom',
          dataIndex: 'nombre',
          position: 1,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Nivell',
          dataIndex: 'nivel',
          position: 2,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Data Creació',
          dataIndex: 'fechaCreacion',
          position: 3,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          render: 'date',
        },
        {
          title: 'Àrea',
          dataIndex: 'fkArea.nombre',
          position: 4,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Classe',
          dataIndex: 'fkClase.nombre',
          position: 5,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Educador',
          dataIndex: 'fkEducador.id',
          position: 6,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          render: 'combo',
          comboId: 'educador',
        },
        {
          title: 'Avaluació',
          dataIndex: 'fkEvaluacion.nombre',
          position: 7,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Rubrica',
          dataIndex: 'fkRubrica.nombre',
          position: 8,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
      ],
      settings: {
        size: config.COMPONENT.TABLE.SIZE,
        bordered: config.COMPONENT.TABLE.BORDERED,
        editable: true,
        multiple: false,
        canCreate: true,
        canDelete: true,
        scroll: { x: true },
      },
      pagination: {
        defaultPageSize: 50,
        pageSizeOptions: ['5', '10', '20', '50'],
        showQuickJumper: config.COMPONENT.SHOW_QUICK_JUMPER,
        showSizeChanger: config.COMPONENT.TABLE.SHOW_SIZE_CHANGER,
        showTotal: config.COMPONENT.TABLE.SHOW_TOTAL,
        size: config.COMPONENT.TABLE.SIZE,
      },
    },
    {
      params: {
        type: 'edit',
        componentId: 'evaluacionevaluacionEdit',
        panelHeader: 'Avaluació',
        panelKey: 'evaluacionevaluacionEdit',
        primaryKey: 'id',
        yPosition: 2,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: true,
        tabIndex: 0,
        tabTitle: 'Avaluació',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 2,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'nombre',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'nivel',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fechaCreacion',
                  yPosition: 1,
                  xPosition: 3,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'fkArea.id',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'fkClase.id',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'fkEducador.id',
                  yPosition: 2,
                  xPosition: 3,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'fkEvaluacion.id',
                  yPosition: 2,
                  xPosition: 4,
                  mustRender: true,
                  width: 6,
                },
                {
                  key: 'fkRubrica.id',
                  yPosition: 2,
                  xPosition: 4,
                  mustRender: true,
                  width: 6,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Nom',
          key: 'nombre',
          type: 'text',
          unique: false,
          validationType: 'text',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Nivell',
          key: 'nivel',
          type: 'number',
          validationType: 'number',
          unique: false,
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Data Creació',
          key: 'fechaCreacion',
          type: 'date',
          unique: false,
          format: 'YYYY-MM-DD',
          displayFormat: 'DD-MM-YYYY',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Àrea',
          key: 'fkArea.id',
          type: 'combo',
          unique: false,
          comboId: 'area',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Classe',
          key: 'fkClase.id',
          type: 'combo',
          unique: false,
          comboId: 'clase',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Educador',
          key: 'fkEducador.id',
          type: 'combo',
          unique: false,
          comboId: 'educador',
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Avaluació',
          key: 'fkEvaluacion.id',
          type: 'combo',
          comboId: 'evaluacion',
          unique: false,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Rubrica',
          key: 'fkRubrica.id',
          type: 'combo',
          comboId: 'rubrica',
          unique: false,
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
        canEdit: true,
        canCreate: true,
        canDelete: true,
      },
    },
  ];

  const componentId = 'EvaluacionDashboard';

  return (
    <DashboardInitializer
      componentId={componentId}
      components={components}
      {...props}
    />
  );
};

export default EvaluacionDashboard;
